module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "logobox"
  }, [_c('div', {
    staticClass: "logon wfull"
  }, [_c('div', {
    staticClass: "logo Fl"
  }, [_c('h1', {
    staticClass: "p25 animated fadeIn"
  }, [_c('router-link', {
    staticStyle: {
      "background": "url('../static/img/logo.png')",
      "background-size": "100% 100%",
      "background-repeat": "no-repeat",
      "margin-left": "5px"
    },
    attrs: {
      "to": "/",
      "title": "奇克（上海）实业有限公司"
    }
  }, [_vm._v("\n                                奇克（上海）实业有限公司")])], 1)]), _vm._v(" "), _c('nav', {
    staticClass: "cd-primary-nav"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "cd-navigation"
    }
  }, [_c('li', {
    staticClass: "current"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("网站首页")])], 1), _vm._v(" "), _c('li', {
    staticClass: "cd-navigation-li3"
  }, [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("关于我们")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/product"
    }
  }, [_vm._v("产品中心")])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("售后服务")])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sfheader"
  }, [
    [_c('el-carousel', {
      attrs: {
        "interval": 5000,
        "arrow": "always"
      }
    }, _vm._l((3), function(item) {
      return _c('el-carousel-item', {
        key: item
      }, [_c('h3', [_c('img', {
        attrs: {
          "src": '../static/img/' + item + '.jpg'
        }
      })])])
    }))]
  ], 2), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "posts-nav wfull"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-trigger",
    attrs: {
      "href": "#cd-navigation"
    }
  }, [_c('span', [_c('em', {
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                Menu\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "cd-navigation-li3"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void"
    }
  }, [_vm._v("新闻中心")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "dbnavhh wfull"
  }, [_c('div', {
    staticClass: "blngwbd Fl",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('h5', [_vm._v("\n                        主营产品\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-%e5%ba%95%e9%83%a8%e4%ba%8c-container"
  }, [_c('ul', {
    staticClass: "footnav",
    attrs: {
      "id": "menu-%e5%ba%95%e9%83%a8%e4%ba%8c"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void"
    }
  }, [_vm._v("粉末丁腈橡胶")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void"
    }
  }, [_vm._v("氢氧化铝")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void"
    }
  }, [_vm._v("氢氧化镁")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "blngwbd Fl"
  }, [_c('h5', [_vm._v("\n                        合作伙伴\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-%e5%ba%95%e9%83%a8%e4%b8%89-container"
  }, [_c('ul', {
    staticClass: "footnav",
    attrs: {
      "id": "menu-%e5%ba%95%e9%83%a8%e4%b8%89"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void"
    }
  }, [_vm._v("韩国KC集团")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void"
    }
  }, [_vm._v("韩国LG化学")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "da14n Fr"
  }, [_c('h5', [_vm._v("\n                        售后支持\n                    ")]), _vm._v(" "), _c('h6', {
    staticClass: "iconfont"
  }, [_vm._v("\n                        微信: 309816335\n                    ")]), _vm._v(" "), _c('h6', {
    staticClass: "iconfont"
  }, [_vm._v("\n                        传真：02139927292\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        周一至周五 9:00-18:00\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "footerDiv"
  }, [_c('div', {
    staticClass: "footer01_end"
  }, [_vm._v("\n                \n                    © 版权所有 奇克（上海）实业有限公司 | "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011402006990"
    }
  }, [_vm._v("沪ICP备17021068号")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cad49406"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 204
// module chunks = 1